import { EventCardType } from "@/components/EventCard/EventCard";
import { GlossarCardElement } from "@/components/Glossar/GlossarCard/GlossarCard";
import { MagazineCardElement } from "@/components/MagazineCard/MagazineCard";
import { PostsGridElementType } from "@/components/PostCard/PostCard";
import { TeamCardElementType } from "@/components/TeamCard/TeamCard";
import { LogosCardElementType } from "@/modules/LogosGrid/fetchLogos";
import { QuotesElementType } from "@/modules/QuoteSliderModule/QuoteSliderModule";
import { ImageType } from "@aleksundshantu/gp-types/acf-module";

export const mockImage: ImageType = {
  url: `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='1000' height='1000'><rect width='100%' height='100%' fill='white'/></svg>`,
  alt: "placeholder image",
  width: 1,
  height: 1,
  acf: {
    link_1: "",
    link_2: "",
    text_1: "",
    text_2: "",
  },
  id: "1",
  title: "",
  filename: "",
  link: "#",
  description: "",
  name: "",
  image_blur: "",
  author: "",
  caption: "",
  date: "",
  modified: "",
  mimetype: "image/png",
  mime_type: "image/png",
  type: "image",
};

export const mockString = (length = 10) => {
  return Array.from({ length })
    .map((element, key) => {
      return key % 2 === 0 ? "" : "";
    })
    .join("");
};

export const mockPost: PostsGridElementType = {
  date: "2020-01-01",
  image: mockImage,
  categories: [],
  title: mockString(),
  excerpt: mockString(),
  link: "#",
  id: 0,
};

export const mockQuote: QuotesElementType = {
  content: mockString(300),
  name: mockString(),
  firma: mockString(),
  position: mockString(),
  image: mockImage,
  preview_image: mockImage,
  rating_stars: 5,
  title: mockString(),
  source: {
    text: mockString(),
    type: "text",
    logo: false,
  },
};

export const mockTeamPost: TeamCardElementType = {
  element: {
    image: mockImage,
    socials: [],
    name: mockString(),
    firstname: mockString(),
    salutation: mockString(),
    position: mockString(),
    company_location: mockString(),
    phone: mockString(),
    mobile_phone: mockString(),
    email: mockString(),
    content: mockString(),
    background_color_class: "has-hellgrau-bg",
    section_margin_class: "is-gapless-margin-top",
    breadcrumb_bg_color: "has-hellgrau-bg",
    end_date: "2020-01-01",
    start_date: "2020-01-01",
    has_single_page: false,
    seo_settings: {
      breadcrumb_title: "",
      seo_title: "",
      seo_metadescription: "",
      social_media_share_description: "",
      exclude_from_search_engines: false,
      social_media_share_image: false,
      show_in_sitemap: false,
    },
    structured_data: "",
  },
  url: "#",
};

export const mockLogo: LogosCardElementType = {
  image: mockImage,
  link: {
    target: "_blank",
    title: "",
    url: "#",
    type: "",
    aria_label: "",
  },
  height: 100,
};

export const mockEvent: EventCardType = {
  id: 1,
  date: "2020-01-01",
  link: "#",
  title: mockString(),
  excerpt: mockString(200),
};

export const mockMagazine: MagazineCardElement = {
  title: mockString(),
  link: "#",
  subline: mockString(30),
  image: mockImage,
  excerpt: mockString(200),
};

export const mockGlossar: GlossarCardElement = {
  title: mockString(),
  content: mockString(50),
  link: "#",
};
